<div class="spotlight-overlay" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="spotlight-container">
    <div class="spotlight-search-box">
      <!-- Search Input -->
      <div class="spotlight-input-wrapper">
        <nb-icon icon="search-outline" class="search-icon"></nb-icon>
        <input
          #searchInput
          type="text"
          class="spotlight-input"
          [placeholder]="'spotlight.placeholder' | translate"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          autocomplete="off"
          spellcheck="false"
        />
        <span class="keyboard-shortcut">{{ getShortcutText() }}</span>
      </div>

      <!-- Results List -->
      <div class="spotlight-results" *ngIf="filteredRoutes.length > 0">
        <div
          *ngFor="let route of filteredRoutes; let i = index"
          class="spotlight-result-item"
          [class.selected]="i === selectedIndex"
          (click)="navigateToRoute(route)"
          (mouseenter)="selectRoute(i)"
        >
          <div class="result-icon">
            <nb-icon [icon]="route.icon || 'arrow-forward-outline'"></nb-icon>
          </div>
          <div class="result-content">
            <div class="result-title"> {{ route.title }}</div>
            <div class="result-breadcrumb" *ngIf="getBreadcrumbText(route)">
              {{ getBreadcrumbText(route) }}
            </div>
          </div>
          <div class="result-arrow" *ngIf="i === selectedIndex">
            <nb-icon icon="corner-down-left-outline"></nb-icon>
          </div>
        </div>
      </div>

      <!-- No Results -->
      <div class="spotlight-no-results" *ngIf="filteredRoutes.length === 0 && searchQuery">
        <nb-icon icon="search-outline" class="no-results-icon"></nb-icon>
        <p>{{ 'spotlight.noResults' | translate }}</p>
      </div>

      <!-- Footer -->
      <div class="spotlight-footer">
        <div class="footer-hint">
          <span class="hint-item">
            <kbd>↑</kbd><kbd>↓</kbd> {{ 'spotlight.navigate' | translate }}
          </span>
          <span class="hint-item">
            <kbd>↵</kbd> {{ 'spotlight.select' | translate }}
          </span>
          <span class="hint-item">
            <kbd>esc</kbd> {{ 'spotlight.close' | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

